/**
 * @generated SignedSource<<85a2189086b94b747b326b386d651849>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useHandleUserAlreadyInBooking_Session$data = {
  readonly currentClientProfile: {
    readonly __typename: string;
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useHandleUserAlreadyInBooking_Session";
};
export type useHandleUserAlreadyInBooking_Session$key = {
  readonly " $data"?: useHandleUserAlreadyInBooking_Session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleUserAlreadyInBooking_Session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHandleUserAlreadyInBooking_Session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "cd0a5a209204f8475ababa870851b3c0";

export default node;
